<bci-wk-modal [closeOnOverlay]="false" [closeOnX]="false" [closeOnEsc]="false">
  <div class="modal-container">
    <div><img [src]="data.asset" alt=""></div>
    <div class="modal-title">
      {{data.title}}
    </div>
    <div class="modal-description">
      {{data.description}}
    </div>

    <bci-wk-modal-actions>
      <div class="modal-buttons">
        <ng-container *ngIf="data.buttons.secondary">
          <button id="secondary" bciWkButtonSecondary [innerHTML]="data.buttons.secondary.description" (click)="onClickBtn(data.buttons.secondary.action)"
            class="wk-margin-right-16"></button>
        </ng-container>
        <ng-container *ngIf="data.buttons.primary">
          <button class="primary" bciWkButtonPrimary [innerHTML]="data.buttons.primary.description" (click)="onClickBtn(data.buttons.primary.action)"></button>
        </ng-container>
      </div>
    </bci-wk-modal-actions>
  </div>
</bci-wk-modal>
